'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.GridPanel'];
module.exports = angular.module('AVRO.ProfileChart.NextPrevButtons', dependencies).controller('ProfileChartNextPrevButtonsController', require('./controllers/ProfileChartNextPrevButtonsController')).directive('rmProfileChartNextPrevButtons', require('./directives/ProfileChartNextPrevButtonsDirective'));